<!--
  File: Booking.vue
-->

<template>
  <v-container>
    <v-tabs v-model="tab" class="pa-0 mt--15" centered>
      <v-tab key="0" class="font-14" to="/">수업안내</v-tab>
      <v-tab key="1" class="font-14">수업예약</v-tab>
      <v-tab key="2" class="font-14" to="/coupon">쿠폰정보</v-tab>
    </v-tabs>

    <v-row v-if="login.studio == 3" class="mt-0 mb--20" justify="center">
      <v-radio-group mandatory row  class="radio">
        <v-radio @click="changed(3)" label="판교점" />
        <v-radio @click="changed(6)" label="분당점" />
      </v-radio-group>
    </v-row>
    <v-row v-if="login.studio == 3" class="mt-3 pa-0 mb-3">
      <v-divider />
    </v-row>

    <v-row class="pa-3 mt-3" justify="center">
      <v-icon class="mr-2" @click="move(-7)">mdi-arrow-left-circle</v-icon>
      <span class="font-14 trim">{{schedules[0].date.substring(5, 10)}} ~ {{schedules[6].date.substring(5, 10)}}</span>
      <v-icon class="ml-2" @click="move(7)">mdi-arrow-right-circle</v-icon>
    </v-row>
    
    <v-row class="pb-3 mt--42" justify="start" v-if="!coupon"><v-btn text>
      </v-btn>
    </v-row>

    <v-row class="pb-3 mt--42" justify="end" v-if="coupon">
      <v-btn class="elevation-0 font-13 pa-1" color="primary" to="/coupon">쿠폰 {{coupon.remain}}개</v-btn>
    </v-row>

    <v-spacer class="pb-6" />
    <v-row class="background seven-cols">
      <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1" class="pa-0">
        <v-toolbar class="elevation-0 mb-1" color="days" height="40" />
        <v-card v-for="(time, i) in times" :key="i" class="elevation-0 mb-1 pa-1" color="background" height="90">
          <span class="text-subtitle-1">{{time}}</span>
        </v-card>
      </v-col>
      
      <div class="pa-0 box" v-for="(day, i) in days" :key="i">
        <v-toolbar dark class="elevation-0 mb-1 grey5--text" color="days" height="40">
          {{day}}
        </v-toolbar>

        <v-card class="elevation-0 mb-1 mr-1 pa-1" :color="bgColor(item)" height="90"
          v-for="(item, j) in schedules[i].items" :key="j"
          v-on="isAvaiable(item) ? { click: () => select(item) } : {}"
        >
          <div v-if="item.time">
            <div :class="classTime(item)" v-if="$vuetify.breakpoint.smAndDown">{{item.time}}</div>
            <div :class="classLesson(item)">{{item.lesson}}</div>
            <div :class="classInstructor(item)">{{item.instructor}}</div>
            <div :class="classTime2(item)" v-if="$vuetify.breakpoint.mdAndUp">{{item.minute}}분</div>
            <!--
            <div :class="classCapacity(item)" v-if="$vuetify.breakpoint.mdAndUp || !statusText(item)">정원 {{item.capacity}}명</div>
            -->
            <div :class="classStatus(item)">{{statusText(item)}}</div>
          </div>
        </v-card>
      </div>
    </v-row>

    <v-row v-if="empty" class="pa-6" justify="center">예정된 수업이 없습니다.</v-row>
    
    <div class="text-center" v-if="dialog">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="justify-center">
            {{dialog.title}}
          </v-card-title>
          <v-card class="elevation-0 ma-3" color="background">              
            <v-card-text class="text-center primary--text font-14 font-weight-bold">
              {{dialog.schedule.date}} ({{util.getDayOfWeek(dialog.schedule.date)}}) {{util.getTime12(dialog.schedule.time)}}
            </v-card-text>
            <v-card-title class="pa-0 justify-center mt--10">
              {{dialog.schedule.lesson}}
            </v-card-title>
            <v-card-text class="mt-1 text-center font-14">
              강사: {{dialog.schedule.instructor}}
            </v-card-text>
          </v-card>
          <div v-if="dialog.confirm">
            <v-card-text class="text-center mt-6 pa-0 font-14">
              {{dialog.text.split('\n')[0]}}
            </v-card-text>
            <v-card-text class="text-center pa-0 font-14">
              {{dialog.text.split('\n')[1]}}
              <span class="font-weight-bold text-decoration-underline">{{dialog.text.split('\n')[2]}}</span>
              {{dialog.text.split('\n')[3]}}
            </v-card-text>
          </div>
          <v-card-text v-if="!dialog.confirm" class="text-center mt-6 pa-0 font-14 accent--text">
            {{dialog.text}}
          </v-card-text>
          <v-card-text class="text-center mt-6">
            문의사항은 {{getStudioName()}} (<a @click="call(getStudioPhone())">{{getStudioPhone()}}</a>)으로 연락주세요.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="normal" @click="dialog = null"
              class="elevation-0 font-14 pr-3 pl-5 pr-5">{{dialog.cancel}}
            </v-btn>
            <v-btn color="primary" @click="confirm()" v-if="dialog.confirm"
              class="elevation-0 font-14 pl-5 pr-5">{{dialog.confirm}}
            </v-btn>
            <v-spacer />
          </v-card-actions>
          <v-spacer class="pa-1"/>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'Booking',

  data () {
    return {
      tab: 1,
      login: null,
      days: [ '월', '화', '수', '목', '금', '토', '일' ],
      times: [],
      empty: false,
      schedules: [],
      coupon: null,
      coupons: 0,
      studios: [],
      studio: 0,
      util: util,
      dialog: null
    }
  },

  methods: {
    move: function (days) {
      for (let i = 0; i < 7; i++) {
        let date = new Date(this.schedules[i].date)
        this.schedules.splice(i, 1, { date: util.getDate(date, days), items: [] })
      }
      this.getSchedule()
    },

    select: function (item) {
      if (item.booking) {
        this.unbook(item)
      }
      else if (item.waiting) {
        this.cancelWaiting(item)
      }
      else {
        this.book(item)
      }
    },

    getHours: function (date, time) {
      let datetime = new Date(date + 'T' + time)
      return (datetime - new Date) / 3600000
    },

    isPast: function (item) {
      return this.getHours(item.date, item.time) < 0
    },

    timeOver: function (item) {
      return this.getHours(item.date, item.time) < 1
    },

    isFull: function (item) {
      return item.booked == item.capacity
    },

    isAvaiable: function (item) {
      if (!item.time) return false
      return !this.isPast(item)
    },

    statusText: function (item) {
      if (item.booking) {
        return this.isPast(item) ? '완료' : '예약'
      }
      else if (item.waiting) {        
        return this.isPast(item) ? '' : '대기중'
      }
      else if (this.isFull(item)) {      
        return '마감'
      }
    },

    bgColor: function (item) {
      if (!item.time) return 'background'
      if (this.isPast(item)) return 'history'
      if (item.waiting) return 'yellow'
      return item.booking ? 'booked' : 'white'
    },

    classTime: function(item) {
      let text = 'text-caption '
      if (item.booking) return text + ' white--text'
      return text + ' black--text'
    },

    classLesson: function(item) {
      let text = 'font-10 font-weight-bold line2 '
      if (item.booking) return text + 'white--text'
      return text + ' primary--text'
    },

    classInstructor: function(item) {
      let text = 'text-caption text-truncate '
      if (item.booking) return text + 'white--text'
      return text + ' color-333'
    },

    classTime2: function(item) {
      let text = 'text-caption '
      if (item.booking) return text + 'white--text'
      return text + ' black--text'
    },

    classCapacity: function(item) {
      let text = 'font-10 '
      if (item.booking) return text + 'white--text'
      return text + ' color--555'
    },

    classStatus: function(item) {
      let text = 'text-caption font-weight-bold '
      if (item.booking) return text + 'white--text'
      if (item.waiting) return text + 'blue--text'
      if (this.isPast(item)) return text + 'color-555'
      if (this.isFull(item)) return text + 'red--text'
    },

    find: function (item, callback) {
      axios.get(`/api/booking/find/${this.login.id}/${item.id}`)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
          callback(null, '네트워크 오류입니다.')
        }
        else if (response.data.schedule) {
          callback(response.data.schedule, null)
        }
        else {
          callback(null, '예약 정보를 가져올 수 없습니다.')
        }
      })
    },

    book: function (item) {
      let title = '수업 예약'
      let text = `이 수업을 예약하시겠습니까?\n예약하시면\n쿠폰 ${item.coupons}매\n가 차감됩니다.`
      let confirm = null
      let cancel = '확인'

      if (this.timeOver(item)) {
        text = '예약시간이 종료되었습니다.'
      }
      else if (this.login.level < 1) {
        text = '준회원은 예약 하실 수 없습니다.'
      }
      else if (!this.coupon || this.coupon.coupon_type != item.coupon_type) {
        text = '사용할 수 있는 쿠폰이 없습니다.'
      }
      else if (util.getDate(new Date(this.coupon.expired), 0) < item.date) {
        text = '쿠폰 유효기간 내의 수업만 예약하실 수 있습니다.'
      }
      else if (this.coupon.remain < item.coupons) {
        text = `사용 가능한 쿠폰이 ${item.coupons}매 이상 필요합니다.`
      }
      else if (this.isFull(item)) {
        title = '예약 대기'
        text = '예약이 마감되었습니다. 대기하시겠습니까?'
        confirm = '대기하기'
        cancel = '취소'
      }
      else {
        confirm = '예약하기'
        cancel = '취소'
      }

      this.dialog = {
        title: title,
        text: text,
        schedule: item,
        confirm: confirm,
        cancel: cancel
      }
    },

    unbook: function (item) {      
      this.find(item, (schedule, error) => {
        if (error) {
          alert(error)
          return
        }
        this.coupons = schedule.booking_coupons

        this.dialog = {
          title: '예약 취소',
          text: `이 예약을 취소하시겠습니까?\n취소하시면\n쿠폰 ${this.coupons}매\n가 반환됩니다.`,
          schedule: item,
          confirm: '실행',
          cancel: '닫기'
        }
      })
    },

    cancelWaiting: function (item) {
      this.dialog = {
        title: '대기 취소',
        text: `예약 대기를 취소하시겠습니까?`,
        schedule: item,
        confirm: '실행',
        cancel: '닫기'
      }
    },

    getStudioName: function () {
      if (this.studio == 3) return '판교점'
      if (this.studio == 6) return '분당점'
      return util.getItem(this.studios, this.studio).text
    },

    getStudioPhone: function () {
      return util.getItem(this.studios, this.studio).phone
    },

    call: function (phone) {
      location.href = 'tel:' + phone
    },

    confirm: function () {
      let title = this.dialog.title
      let schedule = this.dialog.schedule
      this.dialog = null

      if (title == '수업 예약') {
        this.make(schedule)
      }
      else if (title == '예약 취소') {
        this.cancel(schedule)
      }
      else if (title == '예약 대기') {
        this.waiting(schedule)
      }
      else if (title == '대기 취소') {
        this.cancel2(schedule)
      }
    },

    make: function (schedule) {
      let params = new URLSearchParams()
      params.append('user', this.login.id)
      params.append('schedule', schedule.id)
      params.append('coupon', this.coupon.id)
      axios.post('/api/booking/make', params, util.headers)
      .then(response => {
        if (response.data.error) {
          let error = response.data.error
          console.log(error)

          let text = '예약을 할 수 없습니다.'
          if (error == 'Deleted schedule')
            text = '취소된 수업입니다.'
          else if (error == 'Already booked')
            text = '이미 예약 되었습니다.'
          else if (error == 'Fully booked')
            text = '예약이 마감되었습니다.'
          else if (error == 'No coupon' || error == 'Coupon exhausted')
            text = '사용할 수 있는 쿠폰이 없습니다.'
          else if (error == 'Coupon expired')
            text = '쿠폰 유효기간이 만료되었습니다.'
          else if (error == 'Coupon insufficient')
            text = '쿠폰이 부족합니다.'

          this.dialog = {
            title: '수업 예약',
            text: text,
            schedule: schedule,
            cancel: '확인'
          }
        }
        else if (response.data.schedule) {
          schedule.booked += 1
          schedule.booking = response.data.schedule.booking
          this.coupon.remain -= schedule.coupons
          alert('예약되었습니다.')
        }
        else {
          alert('예약을 할 수 없습니다.')
        }
      })
    },

    waiting: function (schedule) {
      let params = new URLSearchParams()
      params.append('user', this.login.id)
      params.append('schedule', schedule.id)
      params.append('coupon', this.coupon.id)
      axios.post('/api/booking/waiting', params, util.headers)
      .then(response => {
        if (response.data.error) {
          let error = response.data.error
          console.log(error)

          let text = '예약 대기 할 수 없습니다.'
          if (error == 'Deleted schedule')
            text = '취소된 수업입니다.'
          else if (error == 'Already waited')
            text = '이미 예약 대기 상태입니다.'
          else if (error == 'No coupon' || error == 'Coupon exhausted')
            text = '사용할 수 있는 쿠폰이 없습니다.'
          else if (error == 'Coupon expired')
            text = '쿠폰 유효기간이 만료되었습니다.'
          else if (error == 'Coupon insufficient')
            text = '쿠폰이 부족합니다.'

          this.dialog = {
            title: '예약 대기',
            text: text,
            schedule: schedule,
            cancel: '확인'
          }
        }
        else if (response.data.waiting) {
          schedule.waiting = response.data.waiting.id
          alert('예약 대기 되었습니다.')
        }
        else {
          alert('예약 대기 할 수 없습니다.')
        }
      })
    },

    cancel: function (schedule) {
      if (this.getHours(schedule.date, schedule.time) < schedule.cancel) {
        alert(`예약 취소는 ${schedule.cancel}시간 전까지 하실 수 있습니다.`)
        return
      }
      if (!this.coupon) {
        alert('예약을 취소하시려면 반환 받으실 쿠폰의 유효기간이 남아 있어야합니다. 운영자에게 문의해주시기 바랍니다.')
        return
      }
      let params = new URLSearchParams()
      params.append('user', this.login.id)
      params.append('schedule', schedule.id)
      params.append('coupon', this.coupon.id)
      axios.post('/api/booking/cancel/' + schedule.booking, params, util.headers)
      .then(response => {
        if (response.data.error) {
          alert(response.data.error)
        }
        else if (response.data.result) {
          schedule.booked -= 1
          schedule.booking = 0
          this.coupon.remain += this.coupons
          alert('예약이 취소되었습니다.')
        }
        else {
          alert('예약을 취소할 수 없습니다.')
        }
      })
    },

    cancel2: function (schedule) {
      let params = new URLSearchParams()
      params.append('user', this.login.id)
      params.append('schedule', schedule.id)
      axios.post('/api/waiting/cancel', params, util.headers)
      .then(response => {
        if (response.data.error) {
          alert(response.data.error)
        }
        else if (response.data.result) {
          schedule.waiting = null
          alert('예약 대기가 취소되었습니다.')
        }
        else {
          alert('예약 대기를 취소할 수 없습니다.')
        }
      })
    },

    getSchedule: function () {
      let url = '/api/booking/list/' + this.studio + '/' + this.schedules[0].date + '/' + this.schedules[6].date
      axios.get(url + '?user=' + this.login.id)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.times.splice(0, this.times.length)
          this.empty = response.data.list.length == 0
          response.data.list.forEach(data => {
            let i = this.schedules.map(schedule => { return schedule.date }).indexOf(data.date)
            if (i >= 0) this.schedules[i].items.unshift(data)
            if (this.times.indexOf(data.time) < 0) this.times.push(data.time)
          })
          this.times.sort()

          this.schedules.forEach(schedule => {
            for(let i in this.times) {
              let time = schedule.items.find(item => item.time === this.times[i])
              if (time == null) {
                schedule.items.splice(i, 0, {})
              }
            }
          })
        }
      })
    },
    
    changed: function (studio) {
      this.studio = studio

      this.schedules.splice(0, this.schedules.length)
      for (let i = 1; i <= 7; i++) {
        this.schedules.push({ date: util.getDateOfWeek(new Date, i), items: [] })
      }
      
      this.getSchedule()
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
      this.studio = this.login.studio
    }
    if (this.login == null) {
      this.$router.push('/login')
      return
    }
    this.$emit('login', this.login)

    util.getCoupon(this.login.id, (coupon, error) => {
      if (error) {
        console.log(error)
      }
      else {
        this.coupon = coupon
      }
    })

    for (let i = 1; i <= 7; i++) {
      this.schedules.push({ date: util.getDateOfWeek(new Date, i), items: [] })
    }
    this.getSchedule()

    util.getStudios((studios, error) => {
      if (error) console.log(error)
      this.studios = studios
      this.studios.shift()
      
      axios.get('/api/studio/find/6')
      .then(response => {
        if (!response.data.error && response.data.studio) {
          let item = response.data.studio
          this.studios.push({
            value: item.id,
            text: item.name,
            link: item.link,
            phone: item.phone,
            address: item.address
          })
        }
      })
    })
  }
}
</script>

<style scoped>
.mt--10 {
  margin-top: -10px;
}
.mt--15 {
  margin-top: -15px;
}
.mt--42 {
  margin-top: -42px;
}
.mb--20 {
  margin-bottom: -20px;
}
.font-10 {
  font-size: 10px;
}
.font-13 {
  font-size: 13px;
}
.font-14 {
  font-size: 14px;
}
.color-333 {
  color: #333333;
}
.color-555 {
  color: #555555;
}
.trim {
  display: inline-block;
  padding-top: 2px;
}
.line2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.seven-cols {
  display: flex;
  flex-wrap: nowrap;
}
.box {
  flex: 1 1 calc(100% / 7);
}
</style>
